
import { useAuth } from "../Auth/AuthProvider";

export default function usePermission(required = []) {
  const { permissions } = useAuth();

  if (!required || required.length === 0) return true;

  return required.some(p => permissions.includes(p));
}


export const disabledDate = current => {
  const currentDate = new Date();
  return current && current > currentDate;
};

export const disabledDatesBeforeYear = current => {
    const currentDate = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(currentDate.getFullYear() - 1);

    return current && (current > currentDate || current < oneYearAgo);
};

// utils/dateTimeUtils.js
export function getCurrentDateTimeString() {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');

    return `${yyyy}${mm}${dd}_${hh}${min}${ss}`;
}


    
    
